const CH2Start = require('./CH2Start');
const CH2Tryon = require('./CH2VirtualTryOn');

let CHANGE2START = null;
let CHANGE2TRYON = null;

/**
This function is used to destroy a specific element with the ID "CHANGE2START"/"CHANGE2TRYON"
and set it to null if it exists. It also retrieves all elements with the class name "ch2_stage-back"
and simulates a click event on each of them. The purpose of this function is to reset the state of
a specific part of the web page back to its original state.
@function
@name CH2Destroy
@returns {void}
*/
function CH2Destroy() {
    if (CHANGE2START) {
        CHANGE2START.destroy();
        CHANGE2START = null;
    }
    if (CHANGE2TRYON) {
        CHANGE2TRYON.handleClose(true);
        CHANGE2TRYON.destroy();
        CHANGE2TRYON = null;
    }
    const allBackeElements = document.getElementsByClassName('ch2_stage-back');
    for (let i = 0; i < allBackeElements.length; i++) {
        allBackeElements[i].click();
    }
}

/**
This function is used to update the configuration of the product in the CH2 module based on the
element that triggered the function, etarget. It first retrieves the 'data-code' and 'data-letter'
attributes from the element, and uses them to update the 'data-code' and 'data-letter' attributes
of the 'buttonAddToCart' element, which is found by traversing up the DOM tree from etarget.
Then, depending on whether the 'etarget' element has class 'ch2_chinese-symbol', the product configurator
mode is set to either 'CHSYMBOLS' or 'SYMBOLS' using the hasChangedMode() method. Finally,
the hasChangedText() method is called on the CHANGE2START product configurator, passing in the
updated 'data-code' and a default value of 0.
@function
@name CH2ChangeConfiguratorSymbol
@param {Element} etarget - The element that triggered the function.
@returns {void}
*/
function CH2ChangeConfiguratorSymbol(etarget) {
    const dataCode = etarget.getAttribute('data-code');
    const dataLetter = etarget.getAttribute('data-letter');
    const buttonAddToCart = etarget
        .closest('.ch2_stage')
        .querySelector('.ch2_configurator_btn_add_to_cart');

    if (buttonAddToCart) {
        buttonAddToCart.setAttribute('data-code', dataCode);
        buttonAddToCart.setAttribute('data-letter', dataLetter);
    }

    if ($(etarget).hasClass('ch2_chinese-symbol')) {
        CHANGE2START.productConfigurator.hasChangedMode('CHSYMBOLS');
    } else {
        CHANGE2START.productConfigurator.hasChangedMode('SYMBOLS');
    }

    CHANGE2START.productConfigurator.hasChangedText(dataCode, 0);
}

/**
This function is used to add the current configuration of the product in the CH2 module to the shopping cart.
It simply calls the 'addToCart' method on the CHANGE2START product configurator object.
@function
@name CH2AddToCart
@returns {void}
*/
function CH2AddToCart() {
    CHANGE2START.addToCart();
}

/**
 * Determines the type of augmented reality (AR) available by detecting the user's device and browser capabilities.
 * @function
 * @name detectARCapabilities
 * @returns {string} - Returns a string representing the type of AR available: "usdz" for Universal Scene Description Zipped AR on iOS devices, "android" for Scene Viewer AR on Android devices, and "qrCode" for unsupported devices such as PCs.
 */
function detectARCapabilities() {
    // TODO: Use Device Detection instead of User Agent
    const isAndroid = /android/i.test(this.navigator.userAgent);
    const isiOS =
        (/iPad|iPhone|iPod/.test(this.navigator.userAgent) && !this.window.MSStream) ||
        (this.navigator.platform === 'MacIntel' && this.navigator.maxTouchPoints > 1);
    const isSafari = /Safari\//.test(this.navigator.userAgent);
    const isFirefox = /firefox/i.test(this.navigator.userAgent);
    const isOculus = /OculusBrowser/.test(this.navigator.userAgent);
    const isiOSChrome = isiOS && /CriOS\//.test(this.navigator.userAgent);
    const isiOSSafari = isiOS && isSafari;
    const isWKWebView = this.window.webkit && this.window.webkit.messageHandlers;
    const supportsSceneViewer = isAndroid && !isFirefox && !isOculus;
    const supportsQuickLook = (() => {
        if (isiOS) {
            if (!isWKWebView) {
                const tempAnchor = this.document.createElement('a');
                return (
                    tempAnchor.relList &&
                    tempAnchor.relList.supports &&
                    tempAnchor.relList.supports('ar')
                );
            }
            return Boolean(
                /CriOS\/|EdgiOS\/|FxiOS\/|GSA\/|DuckDuckGo\//.test(this.navigator.userAgent),
            );
        }
        return false;
    })();
    if ((isiOSChrome || isiOSSafari) && supportsQuickLook) {
        // iOS devices that support QuickLook
        return 'quickLook';
    }
    if (supportsSceneViewer) {
        // Android devices that support Scene Viewer
        return 'sceneViewer';
    }
    // Unsupported devices, use qr code
    return 'qrCode';
}

/**
This function sets up event listeners for various elements in the CH2 module. It retrieves
a number of elements and stores them in constants, and then defines several handler functions
to be attached to event listeners. These handlers are responsible for controlling the behavior
of the CH2 module in response to user actions. The specific actions that are handled include:
opening and closing the 3D player and 3D configurator, adding an item to the shopping cart,
changing the configuration of the product, and handling user input for date selection.
@function
@name setupChange2EventListeners
@returns {void}
*/
function setupChange2EventListeners() {
    // Constants
    // const body = document.body;
    const open3DPlayerBtn = document.getElementById('ch2_show3d_btn'); // -> Change to ch2_open3DPlayer_btn
    const open3DConfiguratorBtn = document.getElementById('ch2_btn-3dconfigurator');
    const close3DPlayerBtn = document.getElementById('ch2_close-player3d');
    const astroSymbols = document.querySelectorAll('.ch2_astro-symbol');
    const allBtnAddToCart = document.querySelectorAll('.ch2_configurator_btn_add_to_cart');
    const confirmDateBtn = document.getElementById('ch2_ok_data'); // -> change to ch2_confirm-date-btn
    const arBtn = document.getElementById('ch2_button-ar');
    const arSupportType = detectARCapabilities();

    const tryOnButton = document.getElementById('ch2_button-tryon');
    const closeVtoButton = document.querySelector('#ch2_close-vto');
    const disagreeButton = document.querySelector('#ch2_deny-ar-privacy');
    const urlParams = new URLSearchParams(window.location.search);
    const autoStartVTO = !!urlParams.get('loadVTO');

    // Handler Functions
    function addOpen3DHandler() {
        open3DPlayerBtn.addEventListener('click', () => {
            if (!open3DPlayerBtn.classList.contains('ch2_active-btn')) {
                open3DPlayerBtn.classList.add('ch2_active-btn');
                CH2Destroy();
                CHANGE2START = new CH2Start(window, pc);
                CHANGE2START.run();
            }
        });
    }

    function addTryOnButtonHandler() {
        if (window.CH2Product.vtoEnabled && window.CH2Product.isTryOn) {
            tryOnButton.classList.remove('ch2_hidden');

            if (autoStartVTO) {
                CH2Destroy();
                CHANGE2TRYON = new CH2Tryon(document, window, navigator, arSupportType, autoStartVTO);
            }
            tryOnButton.addEventListener('click', () => {
                if (!tryOnButton.classList.contains('ch2_active-btn')) {
                    tryOnButton.classList.add('ch2_active-btn');
                    CH2Destroy();
                    CHANGE2TRYON = new CH2Tryon(document, window, navigator, arSupportType, autoStartVTO);
                    if (!autoStartVTO) {
                        CHANGE2TRYON.openTerms();
                    }
                }
            });
            if (closeVtoButton) {
                closeVtoButton.addEventListener('click', () => {
                    CHANGE2TRYON.handleClose(true);
                });
            }
            if (disagreeButton) {
                disagreeButton.addEventListener('click', () => {
                    CHANGE2TRYON.handleClose(true);
                });
            }
        }
    }

    function addOpen3DConfiguratorHandler() {
        open3DConfiguratorBtn.addEventListener('click', () => {
            CH2Destroy();
            CHANGE2START = new CH2Start(window, pc);
            if (window.CH2Product) {
                CHANGE2START.openConfigurator(window.CH2Product);
            }
        });
    }

    function handleStageClick(e) {
        if (!e.target.hasAttribute('data-stage')) return;
        const stageTarget = e.target.getAttribute('data-stage');
        const stageElements = document.getElementsByClassName('ch2_stage');
        for (let i = 0; i < stageElements.length; i++) {
            stageElements[i].style.display = 'none';
        }
        document.getElementById(stageTarget).style.display = 'block';
        CHANGE2START.productConfigurator.hasChangedMode(
            e.target.getAttribute('data-type'),
        );
    }

    function handleBackClick(e) {
        if (!e.target.classList.contains('ch2_stage-back')) return;
        const stageElements = document.getElementsByClassName('ch2_stage');
        for (let i = 0; i < stageElements.length; i++) {
            stageElements[i].style.display = 'none';
        }
        document.getElementById('ch2_stage-0').style.display = 'block';
        const errorDateMsg = document.getElementById('ch2_error_date_msg');
        const inputDateForm = document.getElementById('ch2_input-date-form');
        if (errorDateMsg) errorDateMsg.classList.remove('ch2_error_active');
        if (inputDateForm) inputDateForm.classList.remove('ch2_error_active');
        if (CHANGE2START) CHANGE2START.configuratorReset();
    }

    function addClose3DPlayerHandler() {
        close3DPlayerBtn.addEventListener('click', () => {
            CH2Destroy();
        });

        document.addEventListener('pdpCarousel:change', () => {
            CH2Destroy();
        });
    }

    function addAstroSymbolsHandlers() {
        if (astroSymbols.length > 0) {
            astroSymbols.forEach((symbol) => {
                symbol.addEventListener('click', (e) => {
                    e.preventDefault();
                    CH2ChangeConfiguratorSymbol(e.target);
                });
            });
        }
    }

    /**
     * Launches the AR Quick Look on iOS devices
     * @param {*} usdzSrc  The USDZ file to be loaded
     */
    function launchIOSQuickLookAR(usdzSrc) {
        const anchor = document.createElement('a');
        anchor.setAttribute('rel', 'ar');
        anchor.appendChild(document.createElement('img'));
        anchor.setAttribute('href', usdzSrc);
        anchor.click();
    }

    function addARButtonListener() {
        if (window.CH2Product.isAr) {
            if (arSupportType === 'quickLook') {
                arBtn.addEventListener('click', function () {
                    launchIOSQuickLookAR(`https://static.bulgari.com/3d/usdz/${window.CH2Product.id}.usdz`);
                });
                arBtn.classList.remove('ch2_hidden');
            } else {
                arBtn.classList.add('ch2_hidden');
            }
        }
    }

    function addDateHandler() {
        confirmDateBtn.addEventListener('click', (event) => {
            event.preventDefault();
            const inputDateForm = document.getElementById(
                'ch2_input-date-form',
            );
            const textDate = inputDateForm.value.trim();

            const isInvalidDate =
                textDate.length !== 8 ||
                !textDate.match(/^(([0-9]{2})(\.|-|\/|«|»)){2}([0-9]{2})$/);
            const dateForm = document.getElementById('ch2_date-form');
            const errorTitle =
                dateForm.getElementsByClassName('ch2_config-title')[0];
            const errorDateMsg = document.getElementById('ch2_error_date_msg');
            const inputDateFormClassList = inputDateForm.classList;

            // if (textDate.length !== 7) { isInvalidDate = true; }

            if (isInvalidDate) {
                errorTitle.classList.add('ch2_error_active');
                errorDateMsg.classList.add('ch2_error_active');
                inputDateFormClassList.add('ch2_error_active');
                return false;
            }

            errorDateMsg.classList.remove('ch2_error_active');
            inputDateFormClassList.remove('ch2_error_active');

            CHANGE2START.productConfigurator.hasChangedMode('DATES');
            CHANGE2START.productConfigurator.hasChangedText(textDate);
            return true;
        });
    }

    function addToCartBtnsHandler() {
        allBtnAddToCart.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                CH2AddToCart();
            });
        });
    }

    function addAfterAttributeSelectHandler() {
        $('body').bind('ch2:product3D:afterAttributeSelect', (event, data) => {
            CH2Destroy();

            if (window.CH2Product) {
                const {
                    id,
                    ch2_isAr: isAr,
                    ch2_isTryOn: isTryOn,
                    has3D,
                    ch2_personalizationType: productType,
                    ch2_isConfigurable: isConfigurable,
                    ch2_fontSize: fontSize,
                    ch2_hotStampsFields: hotStampsFields,
                    availableModes,
                    playerCode3D,
                    ch2_position3DEnabled: canChangePosition,
                    ch2_vtoModelVersion: vtoModelVersion,
                    ch2_productVtoEnabled: productVtoEnabled,
                    ch2_productVtoModelVersion: productVtoModelVersion,
                } = data._respProduct;

                window.CH2Product.id = id;
                window.CH2Product.isAr = isAr;
                window.CH2Product.isTryOn = isTryOn;
                window.CH2Product.has3D = has3D;
                window.CH2Product.productType = productType;
                window.CH2Product.isConfigurable = isConfigurable;
                window.CH2Product.fontSize = fontSize;
                window.CH2Product.hotStampsFields = hotStampsFields ? parseInt(hotStampsFields, 10) : null;
                window.CH2Product.availableModes = availableModes;
                window.CH2Product.vtoModel = vtoModelVersion;
                window.CH2Product.vtoEnabled = productVtoEnabled;
                window.CH2Product.vtoModelVersion = productVtoModelVersion;
                window.CH2Product.canChangePosition = canChangePosition;
                window.CH2Product.defaultColor = (productType === 'COLOR' ? '#BF8700' : '#000000');

                // AR Button
                const arButton = document.getElementById('ch2_button-ar');
                if (isAr && arSupportType === 'quickLook') {
                    arButton.classList.remove('ch2_hidden');
                } else {
                    arButton.classList.add('ch2_hidden');
                }

                // 3D Player Button
                const show3dButton = document.getElementById('ch2_show3d_btn');
                if (playerCode3D == null) {
                    show3dButton.classList.add('ch2_hidden');
                } else {
                    show3dButton.classList.remove('ch2_hidden');
                    $('#ch2_3drender-assets-code').html(playerCode3D.replace(
                        /"/g,
                        "'",
                    ));
                    // TODO : Check if PC engine version needs to be changed, see ch2_useLegacyEngine
                }

                // TODO Handle various Tryon types
                // Try On Button
                if (isTryOn) {
                    tryOnButton.classList.remove('ch2_hidden');
                } else {
                    tryOnButton.classList.add('ch2_hidden');
                }

                const contentPositionSelect = document.getElementById(
                    'ch2_content_position_select',
                );
                if (contentPositionSelect) {
                    if (canChangePosition) {
                        contentPositionSelect.classList.remove('ch2_hidden');
                    } else {
                        contentPositionSelect.classList.add('ch2_hidden');
                    }
                }

                // Configuration link
                const configuratorButton = document.getElementById(
                    'ch2_btn-3dconfigurator',
                );
                // Configurator column
                const configuratorDetailColumn = document.getElementById(
                    'ch2_configurator-column',
                );

                if (isConfigurable) {
                    configuratorButton.classList.remove('ch2_hidden');
                    if (configuratorDetailColumn) {
                        configuratorDetailColumn.classList.remove('ch2_pre-stage', 'ch2_hidden');
                    }
                } else {
                    configuratorButton.classList.add('ch2_hidden');
                    if (configuratorDetailColumn) {
                        configuratorDetailColumn.classList.add('ch2_pre-stage', 'ch2_hidden');
                    }
                }

                // Configurator add to cart button
                const configuratorAddToCartButton = document.getElementById('ch2_configurator-add-to-cart');

                if (configuratorAddToCartButton) {
                    if (data._respProduct.available && data._respProduct.shoppable) {
                        configuratorAddToCartButton.classList.remove('ch2_hidden');
                    } else {
                        configuratorAddToCartButton.classList.add('ch2_hidden');
                    }
                }

                // Configurator contact for info button
                const configuratorContactForInfo = document.getElementById('ch2_configurator-btn-notify');

                if (configuratorContactForInfo) {
                    if (!data._respProduct.available || !data._respProduct.shoppable) {
                        configuratorContactForInfo.classList.remove('ch2_hidden');
                    } else {
                        configuratorContactForInfo.classList.add('ch2_hidden');
                    }
                }

                // Recalc selected color dropdown/label
                $('.ch2_color-dropdown').dropdown(
                    'set selected',
                    window.CH2Product.defaultColor,
                );

                if (productType === 'COLOR') {
                    $('.ch2_color-dropdown').removeClass('ch2_disabled');
                } else {
                    $('.ch2_color-dropdown').addClass('ch2_disabled');
                }

                // Close VTO window (if any)
                if (CHANGE2TRYON) {
                    CHANGE2TRYON.handleClose(true);
                    CHANGE2TRYON = null;
                }
            }
        });
    }

    // Adding Handlers
    if (open3DPlayerBtn) {
        addOpen3DHandler();
    }
    if (open3DConfiguratorBtn) {
        addOpen3DConfiguratorHandler();
    }
    if (close3DPlayerBtn) {
        addClose3DPlayerHandler();
    }
    document.addEventListener('click', handleStageClick);
    document.addEventListener('click', handleBackClick);
    if (astroSymbols && astroSymbols.length > 0) {
        addAstroSymbolsHandlers();
    }
    if (arBtn) {
        addARButtonListener();
    }
    if (tryOnButton) {
        addTryOnButtonHandler();
    }
    if (confirmDateBtn) {
        addDateHandler();
    }
    if (allBtnAddToCart && allBtnAddToCart.length > 0) {
        addToCartBtnsHandler();
    }
    addAfterAttributeSelectHandler();
}

document.addEventListener('DOMContentLoaded', setupChange2EventListeners);
